import { render } from "./StaleCallout.vue?vue&type=template&id=3a01215a&scoped=true"
import script from "./StaleCallout.vue?vue&type=script&lang=js"
export * from "./StaleCallout.vue?vue&type=script&lang=js"

import "./StaleCallout.vue?vue&type=style&index=0&id=3a01215a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a01215a"]])

export default __exports__